/**
 * Module dependencies.
 */

import { Box, Stack, Typography } from '@mui/material';
import { Title } from 'components/atoms/title/title';
import { color } from 'styles/utils/colors';
import styled from '@emotion/styled';

/**
 * Export `ContactContainer` styled component.
 */

export const ContactContainer = styled(Box)`
  background-color: #eee;
  padding: 24px;
  max-width: 100%;
  flex: 1;
`;

/**
 * Export `ContactCardTitle` styled component.
 */

export const ContactCardTitle = styled(Title)`
  font-size: 20px;
  font-weight: bold;
  margin-bottom: 24px;
`;

/**
 * Export `ContactTitle` styled component.
 */

export const ContactTitle = styled(Typography)`
  font-size: 16px;
  font-weight: 700;
  color: ${color('primary600')};
  margin-bottom: 4px;
`;

/**
 * Export `ContactRow` styled component.
 */

export const ContactRow = styled(Stack)`
  display: flex;
  align-items: flex-start;
  gap: 12px;
`;

/**
 * Export `ContactIcon` styled component.
 */

export const ContactIcon = styled(Box)`
  font-size: 24px;
  color: ${color('primary400')};
  display: flex;
  align-items: center;
`;

/**
 * Export `ContactText` styled component.
 */

export const ContactText = styled(Typography)`
  font-size: 14px;
  line-height: 14px;
`;

/**
 * Export `MapsLinkWrapper` styled component.
 */

export const MapsLinkWrapper = styled.p`
  font-size: 14px;
  font-weight: 700;
  padding-top: 12px;
  padding-bottom: 16px;
  display: flex;
  flex-direction: row;
  align-items: center;
  color: ${color('primary500')};

  svg {
    font-size: 24px;
    margin-right: 6px;
  }
`;
